import WidgetClassInformationModelBase from '../_generated/modelBases/widget-class-information-model-base';

export default class WidgetClassInformationModel extends WidgetClassInformationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
